import { UserGroupIcon } from '@heroicons/react/24/outline';
import { UserIcon, MonitorIcon } from './assets';
export const navPath = {
  dashboard: {
    index: '/dashboard',
    monitor: {
      index: '/dashboard/monitor',
      admin: '/dashboard/monitor/admin',
      hacker: '/dashboard/monitor/hacker',
    },
    userPanel: '/dashboard/panel',
    resetPassword: '/dashboard/reset-password',
    stats: '/dashboard/stats',
    changelog: '/dashboard/changelog',
  },
  login: '/login',
};

export const user = {
  name: 'Admin',
  email: '',
  imageUrl: UserIcon.default,
};

export const navigation = [
  {
    name: 'monitor',
    icon: UserGroupIcon,
    svg: MonitorIcon.default,
    getHref: (role: string) => {
      if (role === 'ADMIN') {
        return navPath.dashboard.monitor.admin;
      } else if (role === 'HACKER') {
        return navPath.dashboard.monitor.hacker;
      } else {
        return navPath.dashboard.monitor.index;
      }
    },
  },
  // {
  //   name: 'change-password',
  //   icon: UserGroupIcon,
  //   svg: LockIcon.default,
  //   getHref: (role: string) => {
  //     if (role === 'ADMIN') {
  //       return navPath.dashboard.changePassword
  //     } else if (role === 'HACKER') {
  //       return navPath.dashboard.changePassword
  //     } else {
  //       return navPath.dashboard.changePassword
  //     }
  //   },
  // },
];

export const UserRole = {
  MASTER: 'MASTER',
  USER: 'USER',
  HACKER: 'HACKER',
};
